/**
 * Check if the JWT has expired and refresh it if necessary.
 * @returns {string} The JWT token.
 */

async function refreshJwtToken() {
  // check if the JWT has expired
  if (!window.apgigya.jwtIsExpired()) return window.apgigya.getJWT()

  // if the JWT has expired, call the JWT endpoint
  // https://developers.gigya.com/display/GD/accounts.getJWT+JS
  const res = await new Promise((resolve) => {
    window.apgigya.getSecurityToken({ callback: resolve })
  })

  return res.id_token
}

export default refreshJwtToken
